module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['dof-tag', _vm.isActive ? 'dof-tag--active' : 'dof-tag--normal'],
    on: {
      "click": _vm.onClick
    }
  }, [_c('text', {
    class: ['dof-tag-text', _vm.isActive ? 'dof-tag-text--active' : 'dof-tag-text--normal']
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-d5874612!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-tag/index.vue
// module id = 669
// module chunks = 0 1